import React, { useEffect, useState } from 'react'
import ApiRequest from '../Common/restservice';
import { useNavigate, useParams } from 'react-router-dom';
import { errorToast, successToast } from '../Common/showtoast';
import Swal from 'sweetalert2';
import moment from 'moment';
const levelname = ["Entry", "Basic", "Starter", "Business", "Premium", "Classic", "Global"];
const levelprices = [10, 100, 500, 1000, 2500, 5000, 10000];
function Buypackage() {
    const navigate = useNavigate();
    const [tableData, settableData] = useState([]);
    useEffect(() => {
        GetTransactions();
    }, [])
    const buyContractConfirm = async (json) => {
        await Swal.fire({
            title: 'Login Password',
            input: 'password',
            inputLabel: 'Enter your login password to continue',
            inputPlaceholder: 'Enter login password',
            inputValidator: async (value) => {
                if (!value) {
                    return 'Enter valid password'
                }
                json.otp = value;
                json.type = "Activation";
                let res = await ApiRequest("buycontract.asp", "POST", json, { Authorization: localStorage.getItem("token") });
                if (res.status === "error") {
                    if (res.message === "Session Expired") {
                        localStorage.clear();
                        navigate("/login");
                    }
                    return res.message;
                }
                successToast(res.message);
                GetTransactions();
            }
        })
    }
    const GetTransactions = async () => {
        let res = await ApiRequest("GetPurchasePortfolio.asp", "GET", null, { Authorization: localStorage.getItem("token") });
        console.log(res);
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        
        settableData(res.items);
    }
    const BuyContract = async (index) => {
        const confirm = await Swal.fire({
            title: 'Are you sure to purchase this package?',
            text: 'Package cost is Rs.' + levelprices[index],
            showCancelButton: true,
            confirmButtonText: `Confirm`,
        })
        if (!confirm.isConfirmed) {
            return;
        }
        var t = {
            package: index >= 2 ? (index+2) : (index+1),
            topupuser: localStorage.getItem('username')
        };
        await buyContractConfirm(t)
    }
    return (
        <section className="content">
            <div className="row" style={{ display: "flex" }}>
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body" style={{ justifyContent: "center" }}>
                            <h5 className=" mt-3 mb-3">Upgrade</h5>
                            <div className="row" style={{ display: "flex" }}>
                                {
                                    levelprices.map((element, index) => (
                                        <div className="col-lg-3 mt-2 summery-box" key={index}>
                                            <div className="box box-body be-1 fill-icon text-center">
                                                <div className="d-flex align-items-center text-start">
                                                    <div className="w-50 h-50 me-10 bg-danger-light rounded-circle text-center p-5">
                                                        <div className="w-40 h-40 bg-dark rounded-circle d-flex align-items-center">
                                                            <img src={require('../Assets/Images/logo.png')} className='l-h-40' />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <span className="text-fade fs-12">{levelname[index]}</span>
                                                        <h3 className="text-dark hover-primary m-0 fw-600">Rs.{element}</h3>
                                                    </div>
                                                </div>
                                                <h6 className={`mb-1 mt-2 text-center badge badge-primary shk-slow`} style={{ cursor: "pointer" }} onClick={() => BuyContract(index)}>Activate</h6>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                History
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Package</th>
                                            <th>Total Days</th>
                                            <th>Paid Days</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData.length <= 0 ? <tr>
                                                <td colSpan="5">No Details Found</td>
                                            </tr> :
                                                tableData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.CreatedDate}</td>
                                                        <td>{item.package}</td>
                                                        <td>{item.totalroicycle}</td>
                                                        <td>{item.paidcycle}</td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Buypackage
